import { render } from "./CustomAmount.vue?vue&type=template&id=dfc52d6a&scoped=true&lang=html"
import script from "./CustomAmount.vue?vue&type=script&lang=js"
export * from "./CustomAmount.vue?vue&type=script&lang=js"

import "./CustomAmount.vue?vue&type=style&index=0&id=dfc52d6a&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc52d6a"]])

export default __exports__